export default __webpack_public_path__ + "static/media/icon-arrow-down-blue.afeaff4e.svg";